/**
 * The initial/default values the used-search-options vuex store uses for userOptions
 */
export default function() {
    return {
        searchType:'Used Cars',
        d: '',
        paymentSearch: 0,
        stockSearchPaymentSearch: 0,
        minPayment: 0,
        maxPayment: 2000,
        deposit: 2315,
        term: 48,
        annualMileage: 10000,
        distance: -1,
        manufacturer: [],
        model: [],
        trim: [],
        minPrice: 0,
        maxPrice: 0,
        age: '',
        fuelType: [],
        numDoors: '',
        body: [],
        mileage: '',
        transmission: [],
        colour: [],
        annual_tax: '',
        emissions: '',
        keywords: '',
        registration: '',
        engineSize: '',
        nearlyNew: '',
        photo: 'N',
        sortBy: 'recommended',
        stockSearchSortBy: 'recommended',
        carOrVan: [],
        page: 1,
        pageSize: 12,
        // preReg: 0,
        // preRegId: '',
        // Campaign
        // janSale: 0,
        approvedUsedOffer: 0,
        specialOffer: 0,
        new: 0,
        programme: '',
        s_id: '', // id of the known vehicle we want similar vehicles to
        price_alert_id: '',
        hideReserved: '',
        exclusiveOffers: '',
        offers: [],
    };
}